import { render, staticRenderFns } from "./TopUpAmountItem.vue?vue&type=template&id=aed207f0&scoped=true&"
import script from "./TopUpAmountItem.vue?vue&type=script&lang=js&"
export * from "./TopUpAmountItem.vue?vue&type=script&lang=js&"
import style0 from "./TopUpAmountItem.vue?vue&type=style&index=0&id=aed207f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed207f0",
  null
  
)

export default component.exports